import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 20000,
  headers: { "Content-Type": "application/json" },
});

export const submitEnquiry = (payload) =>
  api.post("/enquiries", payload).then((r) => r.data);

export const fetchArticles = (category) =>
  api
    .get("/articles", { params: category ? { category } : {} })
    .then((r) => r.data);

export const fetchArticle = (slug) =>
  api.get(`/articles/${slug}`).then((r) => r.data);

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

export const streamChat = async (payload, onToken) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let msg = "The assistant is unavailable right now.";
    try {
      msg = (await res.json()).detail || msg;
    } catch {}
    throw new Error(msg);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const data = line.slice(5).trim();
      if (data === "[DONE]") return;
      onToken(JSON.parse(data));
    }
  }
};
